import { put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import type { AppAction, AppState } from '@app/state'

import * as User from '../user/state'
import {
  getUserPreferences,
  patchUserPreferences,
} from '../user-preferences/user-preferences.interface'

import * as PatientList from './state'

function* handleLoadPatientListStateFromLocalStorage() {
  yield takeEvery(
    User.ActionType.GetAccountInfoSucceeded,
    loadStateFromLocalStorage,
  )
}

function* loadStateFromLocalStorage(action: AppAction) {
  if (action.type === User.ActionType.GetAccountInfoSucceeded) {
    const appState: AppState = yield select((a) => a)
    const storedUserPreferences = getUserPreferences(action.userId)
    const storedPatientListState = storedUserPreferences.patientList ?? {}
    yield put(
      PatientList.actions.setPatientListState({
        ...appState.patientList,
        ...storedPatientListState,
      }),
    )
  }
}

function* handleSavePatientListStateToLocalStorage() {
  yield takeLatest(
    [
      PatientList.ActionType.SetBirthSex,
      PatientList.ActionType.SetDateOfBirth,
      PatientList.ActionType.SetMrnInputFilter,
      PatientList.ActionType.SetNameInputFilter,
      PatientList.ActionType.SetPageNumber,
      PatientList.ActionType.SetRecordsPerPage,
      PatientList.ActionType.SetSort,
    ],
    saveToLocalStorage,
  )
}

function* saveToLocalStorage(_action: AppAction) {
  const appState: AppState = yield select((a) => a)
  const userId = appState.user.account.userId
  patchUserPreferences(userId, {
    patientList: appState.patientList,
  })
}

export const sagas = {
  handleLoadPatientListStateFromLocalStorage,
  handleSavePatientListStateToLocalStorage,
}
